import { TwoColumnLayout } from '@/components/layouts/TwoColumnLayout'
import { Route, Routes } from 'react-router-dom'

import { LocationMap, LocationsList } from '../components/Settings/Locations'
import { LocationDetails } from '../components/Settings/Locations/LocationDetails'

import type { FC } from 'react'

export const LocationsLeftNavRoutes: FC = () => {
	return (
		<Routes>
			<Route path="*" element={<LocationsList />} />
			<Route path=":placeId" element={<LocationDetails />} />
		</Routes>
	)
}

export const LocationsMainContentRoutes: FC = () => {
	return (
		<Routes>
			<Route path="*" element={<LocationMap />} />
			<Route path=":placeId" element={<LocationMap />} />
		</Routes>
	)
}

export const LocationsRoutes: FC = () => {
	return (
		<TwoColumnLayout left={<LocationsLeftNavRoutes />} right={<LocationsMainContentRoutes />} />
	)
}
